import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export type SearchButtonClickedProps = EventProps

/**
 * @event Search_button_clicked
 * @description Emitted when the search button is clicked.
 */
export const SearchButtonClickedAnalytics = createAnalyticsStatic<SearchButtonClickedProps>(
    ANALYTICS_EVENTS.SEARCH_BUTTON_CLICKED,
)

export default SearchButtonClickedAnalytics
